export enum CharacterAnimation {
    Die = 'die',
    Idle = 'idle',
    DropIdle = 'drop_idle',
    DropRunningRoll = 'drop_running_roll',
    DropRunning = 'drop_running',
    Run = 'run',
    Sitting = 'sitting',
    Falling = 'falling',
    Hurt = 'hurt',
    RotateLeft = 'rotate_left',
    RotateRight = 'rotate_right',
    JumpIdle = 'jump_idle',
    JumpRunning = 'jump_running',
    Punch = 'punch',
    Ducking = 'ducking',
    ScaredRun = 'scared_run',
    Walk = 'walk',
    Driving = 'driving',
    CloseDoorSittingLeft = 'close_door_sitting_left',
    CloseDoorSittingRight = 'close_door_sitting_right',
    CloseDoorStandingLeft = 'close_door_standing_left',
    CloseDoorStandingRight = 'close_door_standing_right',
    StandUpLeft = 'stand_up_left',
    StandUpRight = 'stand_up_right',
    OpenDoorStandingLeft = 'open_door_standing_left',
    OpenDoorStandingRight = 'open_door_standing_right',
    SittingShiftLeft = 'sitting_shift_left',
    SittingShiftRight = 'sitting_shift_right',
    RifleIdle = "idle_rifle",
    RifleAim = 'rifle_aim',
    RifleShoot = 'rifle_firing',
    RifleWalk = "rifle_walk",
    RifleRun = "rifle_run",
    SitDownLeft = 'sit_down_left',
    SitDownRight = 'sit_down_right',
    EnterAirplaneLeft = 'enter_airplane_left',
    EnterAirplaneRight = 'enter_airplane_right',
    SlowRun = 'slow_run',
    IdleReposition = 'idle_reposition',
    CoverIdle = 'idle_cover',
    PistolIdle = 'pistol_idle',
    PistolAimIdle = 'idle_aim_pistol',
    PistolShoot = 'pistol_shoot',
    RunPistol = 'run_pistol',
}
